<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full rounded-25 relative pt-6 px-5 pb-4">
                    <div class="absolute top-6 right-5">
                        <img class="w-18px cursor-pointer"
                             src="../../../../assets/close/close.png"
                             @click="clickClose()">
                    </div>
                    <div class="text-tc-blue-2 text-24 text-center mb-4">
                        <span v-if="!isTypePinPassword">{{lbl.home.login.enter_password}}</span>
                        <span v-else>{{lbl.home.login.enter_pincode}}</span>
                    </div>
                    <InputPassword
                            v-model:inputValue="inputPassword"
                            :isShowPassword="false"
                    ></InputPassword>
                    <div class="text-tc-gray-1 text-20 text-center pt-10px">
                        <span v-if="isTypePinPassword">{{lbl.home.login.condition_pincode}}</span>
                        <span v-else>{{lbl.home.login.condition_password}}</span>
                    </div>
                    <div v-if="errorMsg != ''" class="mt-10px text-tc-orange-1 text-18 text-center">
                        {{errorMsg}}
                    </div>
                    <BlueBtn paddingClass="py-10px mt-4" @click="clickLogin()">
                        <span class="text-22">{{lbl.home.login.login}}</span>
                    </BlueBtn>
                    <div class="text-20 text-tc-gray-1 text-center mt-10px">{{lbl.home.login.cant_login}}</div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import Account from '@/helper/AccountHelper.js';
import RegxHelper from "@/helper/RegxHelper.js";
import CacheHelper from '@/helper/CacheHelper';

//component
import InputPassword from "@/components/Input/simple/InputPassword.vue";
import BlueBtn from '@/components/Button/BlueBtn.vue';
//service
import { AuthLoginModelBuilder } from '@/core/Account/config/AuthConfigModel';
import BzbsAuth from "@/core/Account/service/BzbsAuth";

export default {
    name: "PasswordModal",
    mixins: [LocaleMixin],
    components: {
        InputPassword,
        BlueBtn,
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,
            busModal: null,

            inputUsername: '',
            inputPassword: '',
            phoneNumber: '',
            errorMsg: '',
            passwordType: 'password',
            info: ''
        };
    },
    computed: {
        isTypePinPassword: function() {
            return this.passwordType == 'pin';
        },
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.inputUsername = config.username;
            this.errorMsg = '';
            this.passwordType = config.passwordType;
            this.inputPassword = '';

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickClose: function() {
            this.hide();
            this.controller.sendCallbackClose();
        },
        clickLogin: async function() {
            if (Util.isEmptyStr(this.inputPassword)) {
                this.errorMsg = this.lbl.home.login.mobile_incorrect;
                return;
            }else if(this.inputPassword.length < 8){
                this.errorMsg = this.lbl.home.login.mobile_incorrect;
                return;
            }
            this.getCacheLatLng();
            this.phoneNumber = RegxHelper.removeNotNumber(this.inputUsername);
            let authParams = new AuthLoginModelBuilder()
                        .setUsername(this.phoneNumber)
                        .setPassword(this.inputPassword)
                        .setLatLng(JSON.stringify(this.info))
                        .create()
                        .getParams();

            this.controller.loadingModal.show();
            let loginSuccess = await this.apiLogin(authParams);
            this.controller.loadingModal.hide();

            if (loginSuccess) {
                window.location.replace('/home');
            }
        },
        apiLogin: function(authParams) {
            return new Promise((resolve) => {
                BzbsAuth.apiLogin(authParams).subscribe({
                    next: (data) => {
                        console.log('auth', data);
                        Account.setCacheUser(data);
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err);
                        this.errorMsg = this.lbl.home.login.mobile_incorrect;
                        resolve(false);
                    },
                });
            });
        },
        getCacheLatLng: function() {
            let cache = new CacheHelper('session');
            this.info = cache.getCache('info');
            console.log(this.info)
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;

        .modal-content {
            width: 340px;

            @include mobile {
                width: 100%;
                padding: 16px;
            }
        }
    }
</style>
